import { forwardRef, useMemo } from "react";

import { ALLOW_FILE_EXTENSION } from "../../constants/FileValitaditon";

interface FileInputProps {
  onFileSelect: (files: FileList) => void;
  multiple?: boolean;
  accept?: string[];
}

const formatAcceptString = (extensions: string[]): string =>
  extensions.map(ext => `.${ext}`).join(",");

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ onFileSelect, multiple = false, accept = ALLOW_FILE_EXTENSION }, ref) => {
    const acceptString = useMemo(() => formatAcceptString(accept), [accept]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target;
      if (!files?.length) return;

      onFileSelect(files);

      // 동일한 파일을 다시 선택할 수 있도록 value 초기화
      event.target.value = "";
    };

    return (
      <input
        ref={ref}
        type="file"
        multiple={multiple}
        accept={acceptString}
        onChange={handleChange}
        className="hidden"
      />
    );
  },
);

FileInput.displayName = "FileInput";

export default FileInput;
